import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm, change as changeValue, getFormValues } from 'redux-form'
import { InputForm } from 'controls/Input'
import Button from 'controls/Button'
import { Row, Col } from 'flexbox'
import { common } from '../styles'
import styles from './style'
import customEventValidator from 'app/validators/customEvent'
import DatePicker from 'controls/DatePicker'
import { DropDownForm } from 'controls/DropDown'
import InputTag from 'controls/InputTag'
import AddedParticipants from './AddedParticipants'
import moment from 'moment'

import {
  hourInMilliseconds,
  halfHourInMilliseconds,
  formattedTimeOffset
} from 'app/services/date'

const INITIAL_HOUR = 8
const FINAL_HOUR = 21.5

export class CustomEventForm extends Component {
  static propTypes = {
    style: PropTypes.object,
    centered: PropTypes.bool
  }

  static defaultProps = {
    style: {},
    centered: false
  }
  
  getOffset = h => h * hourInMilliseconds

  getValues = () => {
    const limit = this.getOffset(FINAL_HOUR)
    let hour = this.getOffset(INITIAL_HOUR)
    let values = []
    for (hour; hour < limit; hour += halfHourInMilliseconds) {
      values.push(hour)
    }
    return values
  }

  availableHours = () => {
    return this.getValues().map(t => ({
      value: t.toString(),
      label: formattedTimeOffset(t)
    }))
  }

  setMaxDate = (event, newValue, previousValue, name) => {
    this.props.actions.changeValue('customEventForm', 'endDate', newValue)
  }

  setEndTime = (event, newValue, previousValue, name) => {
    let label = moment(newValue.label, "HH:mm").add('m', 30).format("HH:mm")
    let value = moment.duration(label).asMilliseconds();
    this.props.actions.changeValue('customEventForm', 'endTime',  {value: value, label: label})
  }

  setStartDate = (event, newValue, previousValue, name) => {
    if (newValue < this.props.getValues.startDate) {
      this.props.actions.changeValue('customEventForm', 'startDate', newValue)
    }
  }

  setStartTime = (event, newValue, previousValue, name) => {
    if(this.props.getValues.startTime.value > newValue.value){
      let label = moment(newValue.label, "HH:mm").subtract('m', 30).format("HH:mm")
      let value = moment.duration(label).asMilliseconds();
      this.props.actions.changeValue('customEventForm', 'startTime',  {value: value, label: label})
    }
  }

  render() {
    const {
      handleSubmit,
      invalid,
      style,
      centered,
      onCancel: handleCancel
    } = this.props

    return (
      <form className="form-container" onSubmit={handleSubmit} style={style}>
        <h4>Crear evento</h4>
        <Row>
          <Col xs={12} md={12}>
            <Field
              className="form-input-margin"
              name="title"
              id="title"
              component={InputForm}
              placeholder="Título del evento"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <Field
              className="form-input-margin"
              name="description"
              id="description"
              component={InputForm}
              placeholder="Descripción"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <Field
              className="form-input-margin"
              name="address"
              id="address"
              component={InputForm}
              placeholder="Dirección"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={3}>
            <Field
              name="startDate"
              id="startDate"
              className="form-input-margin"
              component={DatePicker}
              dateFormat="DD/MM/YYYY"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              placeholderText="Inicia"
              minDate={moment()}
              onChange={this.setMaxDate}
            />
          </Col>
          <Col xs={12} md={3}>
            <Field
              component={DropDownForm}
              name="startTime"
              id="startTime"
              className="form-input-margin"
              editable={false}
              hideResetButton={true}
              placeholder="Inicia"
              options={this.availableHours()}
              onChange={this.setEndTime}
            />
          </Col>
          <Col xs={12} md={3}>
            <Field
              name="endDate"
              id="endDate"
              className="form-input-margin"
              component={DatePicker}
              dateFormat="DD/MM/YYYY"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              placeholderText="Termina"
              minDate={moment()}
              onChange={this.setStartDate}
            />
          </Col>
          <Col xs={12} md={3}>
            <Field
              component={DropDownForm}
              name="endTime"
              id="endTime"
              className="form-input-margin"
              editable={false}
              hideResetButton={true}
              placeholder="Termina"
              options={this.availableHours()}
              onChange={this.setStartTime}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12}>
            <Field
              component={InputTag}
              name="participants"
              id="participants"
              className="form-input-margin"
              editable
              placeholder="Para agregar participante, presione enter al terminar de escribir el nombre."
              tags={this.props.participants}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              name="participants"
              id=""
              className="form-input-margin"
              editable
              component={AddedParticipants}
              defaultParticipants={this.props.participants}
            />
          </Col>
        </Row>
        <div className="buttons-container">
          <Row>
            <Col xs={6} sm={6} md={6}>
              <Button color="primary" fullWidth outline onClick={handleCancel}>
                Cancelar
              </Button>
            </Col>
            <Col xs={6} sm={6} md={6}>
              <Button
                color="primary"
                fullWidth
                type="submit"
                disabled={invalid}
              >
                Guardar
              </Button>
            </Col>
          </Row>
        </div>
        <style jsx>{styles}</style>
        <style jsx>{common}</style>
      </form>
    )
  }
}

const formConfig = {
  form: 'customEventForm',
  validate: customEventValidator
}

const mapStateToProps = state => ({
  changeFunction: changeValue(state),
  getValues: getFormValues('customEventForm')(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getFormValues, changeValue
    },
    dispatch
  )
})

export const ReduxCustomEventForm = reduxForm(formConfig)(CustomEventForm)

export default connect(mapStateToProps, mapDispatchToProps)(ReduxCustomEventForm)


